var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKakaobankLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#FFE300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2106 63.7503H48.0305V36.2477H53.2106V63.7503ZM66.7515 49.9993C71.2188 47.0547 74.1672 41.9984 74.1672 36.2483C74.1672 27.1597 66.7967 19.7927 57.7081 19.7927H30.1239C29.595 19.7927 29.1711 20.2166 29.1711 20.7455V79.2537C29.1711 79.7826 29.595 80.2102 30.1239 80.2102H57.7081C66.7967 80.2102 74.1672 72.8433 74.1672 63.7511C74.1672 58.001 71.219 52.9401 66.7515 49.9993Z",
    fill: "#1C1C1C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaobankLogo);
export default __webpack_public_path__ + "static/media/kakaobank-logo.7e24bf72b3b9ad9085af95f9890518da.svg";
export { ForwardRef as ReactComponent };